export const KIJI_TITLE_LIST2024 = {
    KIJI001:"C103で一番の戦利品をまだ紹介していなかった",
    KIJI002:"那須観光に行ったはずなんだ",
}